import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import SectionLabel from "../site/SectionLabel";
import { HOME_SECTIONS } from "@/constants/testIds";

const stats = [
  { value: 15, suffix: "+", label: "Years of design & business experience" },
  { value: 600, suffix: "+", label: "Brands & businesses" },
  { value: 20000, suffix: "+", label: "Creative projects delivered" },
  { text: "Global", label: "Client collaboration" },
];

function Counter({ to, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1600;
    const t0 = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.floor(start + (to - start) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setN(to);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);

  return (
    <span ref={ref}>
      {n.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
}

export default function Impact() {
  return (
    <section
      data-testid={HOME_SECTIONS.impact}
      className="relative bg-ink-900 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <SectionLabel number="07">Business Impact</SectionLabel>
        <h2 className="mt-6 max-w-4xl font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
          Experience you<br />
          <span className="italic text-gold">can build on.</span>
        </h2>

        <div className="mt-16 grid grid-cols-1 divide-y divide-ivory/[0.06] border-y border-ivory/[0.06] md:grid-cols-4 md:divide-x md:divide-y-0">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="p-8 py-12 lg:p-12"
            >
              <div className="flex items-baseline gap-2 font-display text-6xl leading-none tracking-tightest text-gold lg:text-7xl xl:text-8xl">
                {s.text ? <span>{s.text}</span> : <Counter to={s.value} suffix={s.suffix} />}
              </div>
              <div className="mt-6 max-w-[220px] font-sans text-sm text-ivory-muted lg:text-base">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
